import './index.css'
import cn from 'clsx'
import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import type { State } from 'types/redux'
import type { DropdownOption } from 'types/ui'
import {
  togglePlaylistSection,
  updatePlaylistReportParams,
} from '@disco/state-management/actions/ReportActions'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
import type { RootState } from 'store/configureStore'

type OwnProps = {
  // TODO: Fix type
  options: any[]
  value: string
  onChangeMain: (...args: Array<any>) => any
  onChange?: (...args: Array<any>) => any
  disabled?: boolean
  formKey: string
  сlearFieldsAfterChange?: string[]
}

function mapStateToProps(state: RootState, ownProps: OwnProps): any {
  return {
    value: state.reports.playlistReport.form[ownProps.formKey],
  }
}

function mapDispatchToProps(dispatch: any, ownProps: OwnProps): any {
  return {
    onChangeMain(
      _option:
        | (DropdownOption & {
            isAdvancedMetadata: boolean
          })
        | null
        | undefined,
    ) {
      const option = _option || ownProps.options.find(o => !o.value)

      if (!option) return
      let params = {}

      if (ownProps.formKey === 'advancedMetadataKey') {
        // special case for 'All metadata' option
        if (option.isAdvancedMetadata) {
          params = {
            generalMetadataValue: '',
          }
        } else {
          params = {
            advancedMetadataValue: '',
          }
        }

        dispatch(
          togglePlaylistSection('advancedMetadata', option.isAdvancedMetadata),
        )
      }

      const newPlaylistReportParams = {
        ...params,
        [ownProps.formKey]: option.value,
      }

      if (ownProps.сlearFieldsAfterChange) {
        ownProps.сlearFieldsAfterChange.forEach(field => {
          newPlaylistReportParams[field] = ''
        })
      }

      dispatch(updatePlaylistReportParams(newPlaylistReportParams))

      if (ownProps?.onChange) {
        ownProps.onChange(option.value)
      }
    },
  }
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type
type PropsFromRedux = ConnectedProps<typeof connector>

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class ReportSelect extends React.Component<Props> {
  render() {
    const { options, value, onChangeMain, disabled } = this.props
    return (
      <div
        className={`SelectDropdown ${cn({
          'SelectDropdown--Disabled': disabled,
        })}`}
      >
        <CustomDropdown
          options={options}
          multi={false}
          clearable={false}
          value={value}
          onChange={onChangeMain}
          disabled={disabled}
        />
      </div>
    )
  }
}

export default connector(ReportSelect)
